import React from 'react';
import PropTypes from 'prop-types';
import Button from '../../smartAdminUI/Button';

const TaxActionButtons = ({ listingClicked, index }) => {
  const autoTaxPopSelected = () => {
    listingClicked(index);
  };

  return (
    <div className="d-flex">
      <Button
        onClick={autoTaxPopSelected}
        variant="primary"
        data-dismiss="modal"
        data-target="#taxAutoPopModal"
        tooltipText="Select Listing"
      >
        <i className="fal fa-plus" />
      </Button>

    </div>
  );
};

TaxActionButtons.propTypes = {
  listingClicked: PropTypes.func.isRequired,
  index: PropTypes.number.isRequired,
};

export default TaxActionButtons;
